import React from 'react';
import styled from 'styled-components';
import ContactInfo from '../../../../components/V2/ContactInfo';
import BillingAddress from '../../../../components/V2/BillingAddress';
import PaymentInfoV2 from '../../../../components/V2/PaymentInfoV2';
import { Box, Text, Flex } from 'core/ui/atoms';

const OrderDetails = () => {
  return (
    <DetailsContainer>
      <HeaderText>My Details</HeaderText>
      <FlexContainer>
        <FullWidthBox>
          <ContactInfo />
          <BillingAddress title='Delivery Address' />
        </FullWidthBox>
        <FullWidthBox>
          <PaymentInfoV2 title='Payment' />
        </FullWidthBox>
      </FlexContainer>
    </DetailsContainer>
  );
};

const FlexContainer = styled(Flex)`
  flex-direction: row;
  column-gap: 20%;
  ${(p) => p.theme.max('sm')`
    flex-direction: column;
    column-gap: normal;
  `}
`;

const FullWidthBox = styled(Box)`
  width: 100%;
`;

const DetailsContainer = styled(Box)`
  width: 100%;
  padding: 20px;
  background-color: ${(p) => p.theme.colors.backgroundV2};
  border-radius: 8px;
`;

const HeaderText = styled(Text)`
  font-size: 22px;
  font-weight: 400;
  line-height: 15px;
  text-align: center;
  color: ${(p) => p.theme.colors.primaryV2};
  font-family: ${({ theme }) => theme.typography.familyLarken};
`;

export default OrderDetails;
